// extracted by mini-css-extract-plugin
export default {"statistic-component":"StatisticComponent_statistic-component__7KuI6"};